module.exports = __webpack_public_path__ + "img/cha.6cd6d27d.png";